module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gc-Hc-Ia.6f14fa9f.png";